import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HOBEX, PAYMENT_WITH_WEBHOOKS } from 'src/app/app.constants';
import { environment } from 'src/environments/environment';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { ReplacePipe } from 'src/app/pipes/replace.pipe';
import { SpacerComponent } from 'src/app/ui/atoms/spacer/spacer.component';
import { LanguageService } from 'src/app/services/language.service';
import { PaymentService } from 'src/app/services/payment.service';
import { logger, Utils } from 'src/app/utils';
import { Icons } from 'src/app/icons';
import { switchMap, timer } from 'rxjs';
import { CircularProgressBarComponent } from '@progress/kendo-angular-progressbar';

@Component({
    selector: 'app-payment-status',
    templateUrl: './payment-status.component.html',
    imports: [
        ButtonComponent,
        TranslatePipe,
        SVGIconComponent,
        ReplacePipe,
        SpacerComponent,
        CircularProgressBarComponent
    ],
    styleUrl: './payment-status.component.scss'
})
export class PaymentStatusComponent implements OnInit {
  protected icons = Icons;

  private translateService = inject(TranslateService);
  private languageService = inject(LanguageService);
  private paymentService = inject(PaymentService);

  readonly succeedCode: string;

  private lang: string;

  error: any;

  contractId: string;
  pdfLink: string;

  mail: {subject: string, body: string} = {subject: '', body: ''};

  loading = true;

  constructor(private route: ActivatedRoute) {
    this.succeedCode = environment.production
      ? HOBEX.TRANSACTION_SUCCEEDED
      : HOBEX.TEST_TRANSACTION_SUCCEEDED;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      logger.i('params', params);
      const {contractId, lang, ndc} = params;
      if (contractId && lang && ndc) {
        this.contractId = contractId;
        this.lang = lang;
        if (this.languageService.currentLanguage() !== this.lang) {
          this.languageService.changeLanguage(this.lang);
        }
        timer(6000).pipe(switchMap(() => this.paymentService.confirmPaymentStatus(ndc, this.contractId))).subscribe({
          next: (response: any) => {
            if (PAYMENT_WITH_WEBHOOKS ? (response.resultCode === this.succeedCode) : (response.status === 200)) {
              this.pdfLink = response.pdfLink;

              if (environment.production === true) {
                if (response.pdfLink.includes('papinapi.rrsolutions.it')) {
                  this.pdfLink = response.pdfLink.replace(
                    'papinapi.rrsolutions.it',
                    'api.booking.papinsport.com',
                  );
                }
              }

              this.error = undefined;

              this.mail = {
                subject: Utils.encodeMailURIString(
                  this.translateService.instant('mail.subject').replace('[contractId]', this.contractId)
                ),
                body: Utils.encodeMailURIString(
                  this.translateService.instant('mail.body').replace('[contractId]', this.contractId)
                )
              }

              window.parent.postMessage({type: 'hobexResponse', data: response});
            } else {
              this.error = response;
              logger.w('payment status', response);
              window.parent.postMessage({type: 'hobexError', error: response});
            }
            this.loading = false;
          },
          error: (e) => {
            // window.parent.postMessage({type: 'confirmPaymentResponse', data: e});
            this.error = e;
            this.loading = false;
          }
        });
      }
    });
  }

  tryAgain() {
    window.parent.postMessage({type: 'hobexAction', action: 'retry'});
  }

  resetForm() {
    window.parent.postMessage({type: 'hobexAction', action: 'close'});
  }

}
